import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EmpresaContexto = createContext(null);

export const useEmpresaContext = () => {
  const context = useContext(EmpresaContexto);
  if (!context) {
    throw new Error('useEmpresaContext debe usarse dentro de EmpresaContextProvider');
  }
  return context;
};

export const EmpresaContextProvider = ({ children }) => {
  const [empresaDominio, setEmpresaDominio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [esDominioEmpresa, setEsDominioEmpresa] = useState(false);

  useEffect(() => {
    const detectarEmpresa = async () => {
      const hostname = window.location.hostname;

      // Dominios que se consideran "multitenant" (no de empresa)
      const dominiosMultitenant = [
        'localhost',
        '127.0.0.1',
        'preview.emergentagent.com',
      ];

      const esMultitenant = dominiosMultitenant.some(d => hostname.includes(d));

      if (esMultitenant) {
        setEsDominioEmpresa(false);
        setLoading(false);
        return;
      }

      // Buscar empresa por dominio personalizado
      try {
        const response = await axios.get(`${API_URL}/api/auth/empresa-por-dominio`, {
          params: { dominio: hostname }
        });
        if (response.data) {
          setEmpresaDominio(response.data);
          setEsDominioEmpresa(true);
        } else {
          setEsDominioEmpresa(false);
        }
      } catch (err) {
        console.error('Error detectando empresa por dominio:', err);
        setEsDominioEmpresa(false);
      } finally {
        setLoading(false);
      }
    };

    detectarEmpresa();
  }, []);

  const value = {
    empresaDominio,
    esDominioEmpresa,
    loading,
  };

  return (
    <EmpresaContexto.Provider value={value}>
      {children}
    </EmpresaContexto.Provider>
  );
};
